<template>
  <div v-if="loaded">
    <topController />
    <mainController />
    <editor />
    <layerPanel />
    <noviceGuide />
  </div>
</template>

<script>
import topController from "./components/topController.vue";
import mainController from "./components/mainController.vue";
import editor from "./components/editor.vue";
import layerPanel from "./components/layerPanel.vue";
import noviceGuide from "./components/noviceGuide.vue";
import { login } from "@/plugins/utils.js";
export default {
  components: {
    topController,
    mainController,
    editor,
    layerPanel,
    noviceGuide,
  },
  data() {
    return {
      loaded: false,
    };
  },
  created() {
    login(() => {
      this.loaded = true;
    }, this);
  },
};
</script>

<style>
</style>
